<template>
  <div class="page-consulting">
    <div class="header">
      <div class="fixed_width">
        <img src="@/assets/images/header_logo2.png"
             alt="logo">
      </div>
    </div>
    <div class="title">意见咨询</div>
    <div class="content">
      <div class="form">
        <el-form label-position="top"
                 label-width="80px"
                 :rules="rules"
                 ref="formConsulting"
                 :model="formConsulting">
          <el-form-item prop="question"
                        label="您输入遇到的问题:">
            <el-input v-model="formConsulting.question"
                      type="textarea"></el-input>
          </el-form-item>
          <el-form-item style="text-align: center">
            <el-button type="primary"
                       @click="submit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 尾部内容 -->
    <div class="footer">
      <div class="company">
        <div class="name">优与科技专注新能源汽车全生命周期管理咨询解决方案</div>
        <div class="address"
             v-on:click="goto('https://uri.amap.com/marker?position=121.43426,31.157514&name=徐锦记大厦')"><i class="el-icon-location"></i>公司地址：上海市徐汇区南宁路970号李锦记大厦901A</div>
        <div class="goto">
          <span v-on:click="goto('http://www.autobole.com/#/home')">官网入口 <i class="el-icon-d-arrow-right"></i></span>
        </div>
      </div>
    </div>
    <div class="beian">
      @沪ICP备案15009255号-1
    </div>
  </div>
</template>

<script>
import BindhtmlFontSize from '@/mixin/bindhtmlFontSize'
import Ajax from '../../utils/ajax'

export default {
  props: {},
  mixins: [BindhtmlFontSize],
  data() {
    return {
      formConsulting: {
        question: ''
      },
      rules: {
        question: [
          { required: true, message: '请输入您遇到的问题', trigger: 'blur' }
        ]
      },
      request: false
    }
  },
  methods: {
    goto(url) {
      window.open(url, '_blank')
    },
    submit() {
      if (this.request) return

      this.$refs['formConsulting'].validate(valid => {
        if (valid) {
          const baseUrl = 'http://backweb.autobole.net/autoboleManage/aliVin/setClick?'
          const obj = {
            name: 'test',
            content: this.formConsulting.question,
            key: 837430
          }
          const value = baseUrl + Object.keys(obj).map(k => k + '=' + obj[k]).join('&')
          // console.log('quetion', value)
          return Ajax({
            url: value,
            method: 'POST'
          }).then((res) => {
            this.request = true
            const code = res.code
            if (code === 10000) {
              this.$message({
                type: 'success',
                message: '感谢您的反馈'
              })
              this.resetForm()
              // console.log('完成', res)
            }
          })
        }
      })
    },
    resetForm() {
      this.$refs['formConsulting'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-consulting {
  .fixed_width {
    height: 100%;
    max-width: 1000px;
    margin: 0 auto;
  }

  .title {
    padding: 0.35rem;
    font-size: 0.32rem;
    font-weight: 400;
    color: rgba(27, 27, 27, 1);
    line-height: 0.48rem;
    letter-spacing: 0.07rem;
  }

  .header {
    position: relative;
    width: 100%;
    height: 0.9rem;
    border-bottom: 1px solid rgba(243, 243, 243, 1);

    img {
      height: 0.37rem;
      vertical-align: middle;
      margin-left: 0.2rem;
    }

    .fixed_width {
      // position: absolute;
      // top: 50%;
      // transform: translateY(-50%);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .content {
    background: url("../../assets/images/consulting.png");
    /* 背景图片的大小, cover就是长宽百分百， 也可以是百分比 */
    background-size: cover;
    background-position: center;
    /* 背景图片是否重复 */
    background-repeat: no-repeat;
    background-attachment: local;
    width: 100%;
    height: 8.12rem;
    position: relative;

    .form {
      width: 8.03rem;
      // max-height: 90%;
      max-width: 90%;
      height: 6.29rem;
      border: 1px solid rgba(207, 207, 207, 1);
      border-radius: 2px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(255, 255, 255, 1);
      padding: 0.5rem;
    }

    .el-form {
      text-align: left;
      .el-button {
        padding: 0.2rem 0rem;
        width: 3.64rem;
        max-width: 50%;
        font-size: 0.2rem;
        background: rgba(37, 201, 227, 1);
        border-color: #25c9e3;
      }

      /deep/.el-form-item {
        margin-bottom: 0.3rem;
      }

      /deep/.el-form-item__label {
        font-size: 0.2rem;
        font-weight: 400;
        color: rgba(27, 27, 27, 1);
        padding: 0 0 0.1rem;
        line-height: 0.3rem;
        &::before {
          display: none;
        }
      }

      /deep/textarea {
        height: 3.8rem;
        background: rgba(250, 250, 250, 1);
      }
    }
  }

  .footer {
    padding: 0.4rem 0;
    border-bottom: 1px solid rgba(243, 243, 243, 1);
    .company {
      display: inline-block;
      width: 100%;
      div {
        padding: 0.04rem;
      }
      .name {
        font-size: 0.16rem;
        font-weight: 500;
        color: rgba(19, 19, 19, 1);
        line-height: 0.24rem;
        letter-spacing: 1px;
      }

      .address {
        font-size: 0.16rem;
        font-weight: 400;
        color: rgba(97, 97, 97, 1);
        line-height: 0.24rem;
        cursor: pointer;

        i {
          color: #a9a9a9;
          margin-right: 0.1rem;
        }
      }
    }

    .goto {
      font-size: 0.16rem;
      font-weight: 400;
      color: rgba(37, 201, 227, 1);
      line-height: 0.24rem;
      span {
        cursor: pointer;
      }
    }
  }

  .beian {
    font-size: 0.14rem;
    font-weight: 400;
    color: rgba(203, 203, 203, 1);
    line-height: 0.2rem;
    margin-top: 0.2rem;
    margin-bottom: 0.4rem;
    text-align: center;
  }

  // @media only screen and (max-width: 750px) {
  //   .page-consulting {
  //     /deep/.el-form-item {
  //       margin-bottom: 22px !important;
  //     }
  //   }
  // }
}
</style>
